import {Stack} from 'shells/layout/stack/stack';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';
import {RELATIVE_TIMESTAMP_FORMATS} from 'shells/timestamp/types';
import {Body} from 'shells/typography/body';

interface Props {
    entityString: string;
    lastContactedTime: number | null;
    myLastContactedTime: number | null;
}

export function PeepLastContactedPopoverContent(props: Props) {
    return (
        <Stack spacing={16}>
            <Stack spacing={4}>
                <Body isBold={true} color='dark' size='small'>
                    Last contacted by anyone
                </Body>
                {props.lastContactedTime ? (
                    <RelativeTimestamp
                        datetime={props.lastContactedTime}
                        format={RELATIVE_TIMESTAMP_FORMATS.FROM_NOW}
                        className='font-size-normal'
                    />
                ) : (
                    <Body>No one has contacted this {props.entityString}</Body>
                )}
            </Stack>
            <Stack spacing={4}>
                <Body isBold={true} color='dark' size='small'>
                    Last contacted by you
                </Body>
                {props.myLastContactedTime ? (
                    <RelativeTimestamp
                        datetime={props.myLastContactedTime}
                        format={RELATIVE_TIMESTAMP_FORMATS.FROM_NOW}
                        className='font-size-normal'
                    />
                ) : (
                    <Body>You have never contacted this {props.entityString}</Body>
                )}
            </Stack>
        </Stack>
    );
}
